import React, { Component } from 'react';
import $ from 'jquery/dist/jquery.min.js';
import DashboardHeaderIcons from '../dashboardHeaderIcons';
import Filter_Icon from '../css/dark/img/filter-outline.svg';
import Search_Icon from '../css/dark/img/theme-images/search.svg';
import FilterNew from '../css/dark/img/theme-images/filter-new.svg';
import WhFilterPopup from './../Wholesaler/Filter';
import DisFilterPopup from './../Distributor/Filter';
import AdFilterPopup from './../Admin/Filter';
import ConfirmReload from './../../components/ConfirmReload';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment, { relativeTimeRounding } from 'moment';
import { BrowserRouter as Router, Route, NavLink, Link } from 'react-router-dom';
import PubSub from 'pubsub-js';

class TopMenu extends Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handlechangea = this.handlechangea.bind(this);
        this.handleCalendar = this.handleCalendar.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
        // this.handleDropDownChange = this.handleDropDownChange.bind(this);
        this.HandleRXSRadioButton = this.HandleRXSRadioButton.bind(this);
        //this.handleDropDownChange = this.handleDropDownChange.bind(this);
        this.CreateNewFilter = this.CreateNewFilter.bind(this);
        this.ConfirmReloadPopUp = this.ConfirmReloadPopUp.bind(this);
        var _roletype = '', _rolename = '';
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenel") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenel") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
            }
        }
        catch (error) { }
        this.state = {
            dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
            dashboardList: [],
            ConfirmReloadPopUp: false,
            radioButtonSelection: false,
            radioButtonValue: 'totalpaid',
            searchTextSelection: false,
            searchTextType: '',
            searchTextValue: '',
            AdFilterPopup: false,
            WhFilterPopup: false,
            CreateNewFilter: false,
            DisFilterPopup: false,
            ConfirmationMessageTitle: '',
            userdata: JSON.parse(localStorage.getItem('user')),
            UserFilter: [],
            UserFilterList: [],
            SearchDispay: [],
            startDate: new moment(startdate).format("MM/DD/YYYY"),
            endDate: new moment(enddate).format("MM/DD/YYYY"),
            roletype: _roletype,
            rolename: _rolename,
            ClaimType: [
                { id: "totalpaid1", value: "totalpaid", isChecked: true, pname: "Total" },
                { id: "reversed3", value: "reversed", isChecked: false, pname: "Reversed" },
                { id: "netpaid2", value: "netpaid", isChecked: false, pname: "Net" },
                { id: "compensable4", value: "compensable", isChecked: false, pname: "Paid" }
            ]
        }
    }
    CreateNewFilter() {
        this.setState({
            CreateNewFilter: !this.state.CreateNewFilter,
        });
        if ($('.filterNewDesign').hasClass('active')) {
            $('.filterDropdown').slideToggle();
            $('.filterNewDesign').toggleClass('active');
        }
    }
    toggleWhFilterPopup() {
        var wname = this.state.userdata.wholesaler;
        this.setState({
            WhFilterPopup: !this.state.WhFilterPopup,
            dashboardName: wname
        });
        $("body").toggleClass('no-scroll');
    }
    toggleAdFilterPopup() {
        this.setState({
            AdFilterPopup: !this.state.AdFilterPopup,
        });
        $("body").toggleClass('no-scroll');
    }
    toggleDisFilterPopup() {
        var wname = this.state.dashboardName;
        this.setState({
            DisFilterPopup: !this.state.DisFilterPopup,
            dashboardName: wname
        });
        $("body").toggleClass('no-scroll');
    }
    updatedateonfilterclick() {
        try {
            if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
                $(document).ready(function () {
                    $('.first-one .form-control').val(localStorage.getItem('User_Start_Date'));
                });

            }
            if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
                $(document).ready(function () {
                    $('.second-one .form-control').val(localStorage.getItem('User_End_Date'));
                });
            }
        }
        catch (error) {
        }
    }
    HandleRXSRadioButton(e) {
        var NewHDType = e.target.value;
        try {
            if (NewHDType != 'totalpaid') {
                let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter'));
                if (ExistJson == null || ExistJson.hasOwnProperty('PBM') == false || ExistJson["PBM"].length > 1 || ExistJson['PBM'].indexOf('HD') == -1) {
                    this.setState({ radioButtonSelection: true, radioButtonValue: NewHDType, ConfirmationMessageTitle: 'This selection is only available for PCN: HD. Your current filter selection(s) will be updated accordingly. Do you wish to continue?' });
                    try {
                        let CT = this.state.ClaimType;
                        CT.forEach(c => {
                            if (c.value == e.target.value) {
                                c.isChecked = true;
                            }
                            else {
                                c.isChecked = false;
                            }
                        });
                        this.setState({ ClaimType: CT });
                    }
                    catch (error) { }
                    this.ConfirmReloadPopUp(NewHDType);
                    return false;
                }
            }
        }
        catch (error) { }
        try {
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == e.target.value) {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) { }
        try {
            try {
                var LocalHDType = localStorage.getItem('Updated_HD_Type');
                localStorage.setItem('Prev_HD_Type', LocalHDType);
                localStorage.setItem('Updated_HD_Type', NewHDType);
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time', newDate);
                this.handlechangea();
            } catch (error) {
            }
            this.handlechangea();
        }
        catch (error) { }
    }
    HandleRadioButtonConfirmation(selectedRadioButton) {
        try {
            this.setState({ radioButtonSelection: false, radioButtonValue: selectedRadioButton });
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == selectedRadioButton) {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) { }
        try {
            try {
                this.Create_Advance_FIlter_Json_Without_Refresh('PBM', 'HD', 'RadioSelect');
                var LocalHDType = localStorage.getItem('Updated_HD_Type');
                localStorage.setItem('Prev_HD_Type', LocalHDType);
                localStorage.setItem('Updated_HD_Type', selectedRadioButton);
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time', newDate);
            } catch (error) {
            }
            this.handlechangea();
        }
        catch (error) { }
    }
    HandleSearchTextConfirmation(e) {
        this.setState({ searchTextSelection: false });
        //this.ConfirmReloadPopUp();
        //this.Create_Advance_FIlter_Json_Without_Refresh(e[0], e[1]);
        let CT = this.state.ClaimType;
        CT.forEach(c => {
            if (c.value == 'totalpaid') {
                c.isChecked = true;
            }
            else {
                c.isChecked = false;
            }
        });
        this.setState({ ClaimType: CT });
        this.Create_Advance_FIlter_Json_Without_Refresh(e[0], e[1], 'Search');
        var LocalHDType = localStorage.getItem('Updated_HD_Type');
        localStorage.setItem('Prev_HD_Type', LocalHDType);
        localStorage.setItem('Updated_HD_Type', 'totalpaid');
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        this.handlechangea();

    }
    Create_Advance_FIlter_Json_Without_Refresh(nodetype, nodevalue, Confirm_Type) {
        var Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter'));
        var arr = [];
        if (Created_Advance_Filter != null && Created_Advance_Filter != '' && Created_Advance_Filter != undefined && Created_Advance_Filter != "null" && Created_Advance_Filter != "{}") {
            if (Confirm_Type == 'RadioSelect') {
                if (Created_Advance_Filter.hasOwnProperty('PBM')) {
                    //if (Created_Advance_Filter["PBM"].length > 1) {
                    let Temp_Json = Created_Advance_Filter;
                    Created_Advance_Filter["PBM"].splice(0, Temp_Json["PBM"].length);
                    //}
                }
            }
            var IsMatched = false;
            Object.keys(Created_Advance_Filter).forEach(key => arr.push({ Name: key, Value: Created_Advance_Filter[key] }))
            for (var ij = 0; ij < arr.length; ij++) {
                if (arr[ij].Name == nodetype) {
                    IsMatched = true;
                    let checkavail = 0;
                    Created_Advance_Filter[nodetype].map((e1, i1) => {
                        if (e1.toLowerCase() == nodevalue.toLowerCase()) {
                            checkavail = checkavail + 1;
                        }
                    });
                    if (checkavail == 0) {
                        Created_Advance_Filter[nodetype].push(nodevalue);
                        localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
                        let newDate = new Date();
                        localStorage.setItem('Filter_Last_Update_Time', newDate);
                        localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                        // this.handlechangea();

                    }
                    break;
                }
                else {
                    continue;
                }
            }
            if (IsMatched == false) {
                try {
                    var JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                    let TempJson = JSON.stringify(Created_Advance_Filter).replace('{', '').replace('}', '');
                    TempJson = '{' + TempJson + ',' + JsonData + '}';
                    localStorage.setItem('Advance_Filter', TempJson);
                    let newDate = new Date();

                    localStorage.setItem('Filter_Last_Update_Time', newDate);
                    localStorage.setItem('Updated_AdFilter_Status', TempJson);
                    //this.handlechangea();

                }
                catch (error) {
                }
            }

        }
        else {
            var JsonData = '';
            try {
                JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                localStorage.setItem('Advance_Filter', JSON.stringify(JSON.parse(JsonData)["dataset"]));
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time', newDate);
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
            }
            catch (error) {

            }
        }
    }
    handleChangeDate(e) {
        this.props.handleChangeDateNew(e);
    }
    handlechangea(e) {
        this.props.handeChangefilter(e);
    }
    GetUserFilterSet(FilterName, FilterJson, DashboardId) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ FilterName, FilterJson, DashboardId })
            };
            return fetch(`/api/Filter/GetUserAdFilter`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ UserFilterList: apidata[0]["filterset"] });
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    componentWillUnmount() {
        PubSub.unsubscribe(this.token)
    }
    subscriber(msg, data) {
        try {
            document.getElementById('totalpaid1').checked = true;
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == 'totalpaid') {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) {
        }
    }
    componentDidMount(e) {

        $('.readonly-attr').attr('readonly', 'readonly');

        this.token = PubSub.subscribe('PBM', this.subscriber.bind(this))
        // outside click close filter
        $(document).click(function (event) {
            event.stopPropagation();
            $('.filterDropdown').slideUp();
            $('.filterNewDesign').removeClass('active');
            $('.filterDropdown2').slideUp();
            $('.filterNewDesign2').removeClass('active');
            $('#myInputautocomplete-list').slideUp();
        });
        $('.filter-over').click(function (event) {
            event.stopPropagation();
            $('.filterDropdown').slideToggle();
            $('.filterNewDesign').toggleClass('active');
            $('#myInputautocomplete-list').slideUp();
            $('.filterDropdown2').slideUp();
            $('.filterNewDesign2').removeClass('active');
        });
        $('.filter-over2').click(function (event) {
            event.stopPropagation();
            $('.filterDropdown2').slideToggle();
            $('.filterNewDesign2').toggleClass('active');
            $('#myInputautocomplete-list').slideUp();
            $('.filterDropdown').slideUp();
            $('.filterNewDesign').removeClass('active');
        });

        var user = JSON.parse(localStorage.getItem('user'));
        //if (user) {
        //    this.setState({
        //        ...this.state,
        //        dashboardList: user.dList
        //    })
        //    this.props.dashboardListRendered($("#dashboard_select option:selected").text());
        //}

        if (this.state.userdata.userrole == "Admin") {
            this.GetFilterData('/api/admin/Admin_filter', "admin");
        }
        else if (this.state.userdata.userrole == "SubAdmin") {
            localStorage.setItem('Updated_Filter_Status', 'groupnumber_all_0');
        }
        else if (this.state.userdata.userrole == "Wholesaler") {
            this.GetFilterData('/api/ws/wholesaler_filter', escape(this.state.dashboardName.replace(" Dashboard (wholesaler)", "").trim()));
        } else if (this.state.userdata.userrole == "Distributor") {
            if (this.state.userdata.wholesaler == "Avenel") {
                this.GetFilterData('/api/ds/distributor_filter', escape(this.state.userdata.email.trim()));
            }
            else {
                this.GetFilterData('/api/ds/distributor_filter', escape(this.state.dashboardName.replace(" Dashboard", "").trim()));
            }
        }
        this.GetUserFilterSet('', '', this.state.userdata["dList"][0].dashboardId);

        $("#myInput").focus(function () {
            $('.searchSection').addClass('active');
        });

        $("#myInput").focusout(function () {
            $('.searchSection').removeClass('active');
        });


        if (this.state.userdata.userrole == "Admin") {
            try {
              var saved_type = localStorage.getItem('Updated_HD_Type')
                let CT = this.state.ClaimType;
                if (saved_type != undefined && saved_type != null && saved_type != '' && saved_type != 'null') {
                  
                    CT.forEach(c => {
                        if (c.value === saved_type) {
                            c.isChecked = true;
                        }
                        else {
                            c.isChecked = false;
                        }
                    });
                }
                else {
                    CT.forEach(c => {
                        if (c.value === 'compensable') {
                            c.isChecked = true;
                        }
                        else {
                            c.isChecked = false;
                        }
                    });
                }
                this.setState({ ClaimType: CT });
                var checkforfilter = localStorage.getItem('Advance_Filter');
                if (checkforfilter != undefined && checkforfilter != null && checkforfilter != '' && checkforfilter != 'null') {
                    let checked_type = this.state.ClaimType.filter((x) => {
                        return x.isChecked === true;
                    });
                    if (checked_type.length > 0) {
                        window.localStorage.setItem('Advance_Filter', checkforfilter);
                        window.localStorage.setItem('Updated_HD_Type', checked_type[0].value);
                    } else {
                        window.localStorage.setItem('Advance_Filter', checkforfilter);
                        window.localStorage.setItem('Updated_HD_Type', 'totalpaid');
                    }
                }
                else {
                    if (checkforfilter === 'null') {
                        window.localStorage.setItem('Advance_Filter', null);
                        window.localStorage.setItem('Updated_HD_Type', 'totalpaid');
                    }
                    else {
                        window.localStorage.setItem('Advance_Filter', '{"PBM":["HD"]}');
                        window.localStorage.setItem('Updated_HD_Type', 'compensable');
                    }
                }
            }
            catch (error) { }
        }
        else {
            try {
                let CT = this.state.ClaimType;
                CT.forEach(c => {
                    if (c.value === 'totalpaid') {
                        c.isChecked = true;
                    }
                    else {
                        c.isChecked = false;
                    }
                });
                this.setState({ ClaimType: CT });
                window.localStorage.setItem('Updated_HD_Type', 'totalpaid');
            }
            catch (error) { }
        }

    }
    GetFilterData(API_URL, uname) {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uname })
        };
        return fetch(API_URL, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ UserFilter: apidata });
                    localStorage.setItem('Prev_Filter_Status', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                    localStorage.setItem('Updated_Filter_Status', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                    localStorage.setItem('Prev_AdFilter_Status', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                    localStorage.setItem('Updated_AdFilter_Status', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);

                }
                catch (error) {
                }
            });
    }
    HandleSearchFocus = e => {
        if ($('#myInput').val().length == 0) {
            this.setState({ SearchDispay: null });
        }
    }
    HandleSearchKeyUp = e => {
        if ($('#myInput').val().length >= 2) {
            this.GetSearchDataList($('#myInput').val(), this.state.roletype, this.state.rolename, this.state.userdata.wholesaler_Id.toString());
        }
        else {
            this.setState({ SearchDispay: null });
        }
    }
    GetSearchDataList(text, roletype, rolename, whname) {
        $('#myInputautocomplete-list').css('display', 'block');
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text, roletype, rolename, whname })
        };
        return fetch(`/api/Filter/SearchOnTypeText`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ SearchDispay: apidata });
                }
                catch (error) {
                    this.setState({ SearchDispay: null });
                }
            });
    }
    HandleSearchItemClick = e => {
        $('#myInput').val('');
        $('#myInputautocomplete-list').css('display', 'none');
        this.setState({ SearchDispay: [] });
        var nodevalue = $(e.target).attr('nodevalue');
        var nodetype = $(e.target).attr('nodetype');
        if (nodetype.toLowerCase() == "prescribename") {
            nodetype = "Prescriber";
        }
        try {
            if (nodetype == "PBM" && (nodevalue == "CRX" || nodevalue == "HDX" || nodevalue == "HRX") && $("input[name=rxsprocrss]:checked").val() != "totalpaid") {
                this.setState({ searchTextSelection: true, searchTextType: nodetype, searchTextValue: nodevalue, ConfirmationMessageTitle: 'This Selection will work only for Total Paid' });
                //this.ConfirmReloadPopUp($("input[name=rxsprocrss]:checked").val());
                this.ConfirmReloadPopUp_SearchText(nodetype, nodevalue);
                return false;
            }
            else {
                this.Create_Advance_FIlter_Json(nodetype, nodevalue);
            }
        }
        catch (error) { }

    }
    Create_Advance_FIlter_Json(nodetype, nodevalue) {
        var Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter'));
        var arr = [];
        if (Created_Advance_Filter != null && Created_Advance_Filter != '' && Created_Advance_Filter != undefined && Created_Advance_Filter != "null" && Created_Advance_Filter != "{}") {
            var IsMatched = false;
            Object.keys(Created_Advance_Filter).forEach(key => arr.push({ Name: key, Value: Created_Advance_Filter[key] }))
            for (var ij = 0; ij < arr.length; ij++) {
                if (arr[ij].Name == nodetype) {
                    IsMatched = true;
                    let checkavail = 0;
                    Created_Advance_Filter[nodetype].map((e1, i1) => {
                        if (e1.toLowerCase() == nodevalue.toLowerCase()) {
                            checkavail = checkavail + 1;
                        }
                    });
                    if (checkavail == 0) {
                        Created_Advance_Filter[nodetype].push(nodevalue);
                        localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
                        let newDate = new Date();
                        localStorage.setItem('Filter_Last_Update_Time', newDate);
                        localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                        this.handlechangea();

                    }
                    break;
                }
                else {
                    continue;
                }
            }
            if (IsMatched == false) {
                try {
                    var JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                    let TempJson = JSON.stringify(Created_Advance_Filter).replace('{', '').replace('}', '');
                    TempJson = '{' + TempJson + ',' + JsonData + '}';
                    localStorage.setItem('Advance_Filter', TempJson);
                    let newDate = new Date();

                    localStorage.setItem('Filter_Last_Update_Time', newDate);
                    localStorage.setItem('Updated_AdFilter_Status', TempJson);
                    this.handlechangea();

                }
                catch (error) {
                }
            }

        }
        else {

            var JsonData = '';
            try {
                JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                localStorage.setItem('Advance_Filter', JSON.stringify(JSON.parse(JsonData)["dataset"]));
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time', newDate);
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                this.handlechangea();

            }
            catch (error) {

            }
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        localStorage.setItem('User_Start_Date', changedStartDate);
        localStorage.setItem('User_End_Date', changedEndDate);
        this.handleChangeDate(changedStartDate + '-' + changedEndDate);
        try {
            $('.first-one .form-control').val(changedStartDate);
            $('.second-one .form-control').val(changedEndDate);
        }
        catch (error) {
        }
    }
    filterDropdown() {
        $('.filterDropdown').slideToggle();
        $('.filterNewDesign').toggleClass('active');
    }
    handleAdFilterClick = e => {
        e.stopPropagation();
        try {
            let TagDynamic = '';
            let fid = parseInt($(e.target).attr('filterid'));
            let SelectedFiltorJson = this.state.UserFilterList.filter((did) => did.dashboardId == fid);
            //this.GetUserFilterMatchingTag_FilterClick(this.state.roletype, this.state.rolename, this.state.startDate, this.state.endDate, JSON.stringify(JSON.parse(SelectedFiltorJson[0]["filterJson"])["dataset"]), fid);
            $('.filterDropdown').slideToggle();
            try {
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(JSON.parse(SelectedFiltorJson[0]["filterJson"])["dataset"]));
                localStorage.setItem('Advance_Filter', JSON.stringify(JSON.parse(SelectedFiltorJson[0]["filterJson"])["dataset"]));
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time', newDate);
            } catch (error) {
            }
            if ($("input[name=rxsprocrss]:checked").val() != "totalpaid") {
                let CT = this.state.ClaimType;
                CT.forEach(c => {
                    if (c.value == 'totalpaid') {
                        c.isChecked = true;
                    }
                    else {
                        c.isChecked = false;
                    }
                });
                this.setState({ ClaimType: CT });
                var LocalHDType = localStorage.getItem('Updated_HD_Type');
                localStorage.setItem('Prev_HD_Type', LocalHDType);
                localStorage.setItem('Updated_HD_Type', 'HD');
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time', newDate);
            }

            this.handlechangea();
        }
        catch (error) { }
    }
    ConfirmReloadPopUp(type = null) {
        /* if (this.state.ConfirmReloadPopUp == true) {*/
        try {
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == localStorage.getItem('Updated_HD_Type')) {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) { }
        /* }*/
        this.HandleRadioButtonConfirmation(type);
        //this.setState({
        //    ConfirmReloadPopUp: !this.state.ConfirmReloadPopUp
        //});

    }
    ConfirmReloadPopUp_SearchText(type, value) {
        try {
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == localStorage.getItem('Updated_HD_Type')) {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) { }
        /* }*/
        let fieldValue = [];
        fieldValue.push(type);
        fieldValue.push(value);
        this.HandleSearchTextConfirmation(fieldValue);
    }
    handleFilterClick(e) {
        e.stopPropagation();
        var dropdownText = $(e.target).attr('data-id');
        $('.filter-over2').text(dropdownText);
        $('.filterDropdown2').slideToggle();
        $('.filterNewDesign2').toggleClass('active');
        $('#myInputautocomplete-list').slideUp();
        var LocalUserType = localStorage.getItem('Updated_UserType_Select');
        localStorage.setItem('Prev_UserType_Select', LocalUserType);
        localStorage.setItem('Updated_UserType_Select', dropdownText);
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        this.handle_UserType(dropdownText);
    }
    handle_UserType(e) {
        this.props.handleChangeAllDirectOverride(e);
    }
    handleBrokerFilter = e => {
        e.stopPropagation();
        var dropdownText = $(e.target).attr('data-id');
        $('.filter-over2').text(dropdownText);
        $('.filterDropdown2').slideToggle();
        $('.filterNewDesign2').toggleClass('active');
        $('#myInputautocomplete-list').slideUp();
        var LocalUserType = localStorage.getItem('Updated_UserType_Select');
        localStorage.setItem('Prev_UserType_Select', LocalUserType);
        localStorage.setItem('Updated_UserType_Select', dropdownText);
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        this.handle_UserType(dropdownText);
    }
    render() {
        this.updatedateonfilterclick();
        return (
            <div id="dashboard_header" className="big_dash_header">
                <div className="dashboard-icons">

                    <DashboardHeaderIcons />

                </div>
                <div id="dashboard_header_inner">
                    <div id="dashboard-back-button"></div>
                    <div id="dashboard_header_select" className={this.state.userdata.isBrokerTypeUser ? 'broker-active' : ''}>
                        <DateRangePicker
                            initialSettings={{
                                startDate: this.state.startDate,
                                endDate: this.state.endDate,
                                maxDate: moment().toDate(),
                                locale: {
                                    format: 'MM/DD/YYYY'
                                }
                            }}
                            onApply={this.handleCalendar}>
                            <div className="react-bootstrap-daterangepicker-container">
                                <div className="react-datepicker_input-container first-one">
                                    <input type="text" className="form-control first readonly-attr" value={this.state.startDate} />
                                </div>
                                <div className="react-datepicker_input-container second-one">
                                    <input type="text" className="form-control readonly-attr" value={this.state.endDate} />
                                </div>
                            </div>
                        </DateRangePicker>
                        <div className={this.state.userdata.userrole == "Distributor" || (this.state.userdata.userrole == "Wholesaler" && this.state.userdata.overrideCount > 0) ? 'searchSection add-over' : 'searchSection'}>
                            <img className="SearchIcon" src={Search_Icon} alt="" />

                            <form autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
                                <div className="autocomplete">
                                    <input id="myInput" type="text" name="myCountry" placeholder="Search" className="form-control searchFilter" onFocus={this.HandleSearchFocus} onKeyUp={this.HandleSearchKeyUp} />
                                    {
                                        this.state.SearchDispay != null ? this.state.SearchDispay[0] ?
                                            <div id="myInputautocomplete-list" className="autocomplete-items">
                                                {
                                                    this.state.SearchDispay.map((item, index) => {
                                                        let n_name = "";
                                                        if (index < 5) {

                                                            if (item.cname == "PBM") {
                                                                n_name = "PCN";
                                                            }
                                                            else {
                                                                n_name = item.cname;
                                                            }
                                                            return (<div className="searchitempopulate" nodename={item.cname} nodevalue={item.cvalue} nodetype={item.ctype} onClick={this.HandleSearchItemClick}>{n_name}
                                                                <span nodename={item.cname} nodevalue={item.cvalue} nodetype={item.ctype} >{item.cvalue}</span>
                                                            </div>
                                                            )
                                                        }
                                                        else {
                                                            return;
                                                        }
                                                    })}
                                            </div> : null : null
                                    }
                                </div>
                            </form>

                        </div>
                        <div className="filterNewDesign">
                            <div className="filter-over">
                                <img className="FilterIcon" onClick={this.filterDropdown} src={FilterNew} alt="" />
                            </div>
                            <div className="filterDropdown">

                                <NavLink to="/filter" activeClassName="active"><span className="create-new-filter">Create New Filter</span></NavLink>
                                {
                                    this.state.UserFilterList != null ?
                                        <ul className="filter-bottom">
                                            {this.state.UserFilterList.map((e1, i1) => {
                                                return (
                                                    <li filterid={e1.dashboardId} onClick={this.handleAdFilterClick.bind(this)}>
                                                        <span filterid={e1.dashboardId} onClick={this.handleAdFilterClick.bind(this)}>{e1.filterName}</span>
                                                    </li>
                                                )
                                            })}
                                        </ul> : null
                                }
                            </div>
                        </div>
                        {
                            (this.state.userdata.userrole == "Wholesaler" && this.state.userdata.overrideCount > 0) ?
                                <div className="filterNewDesign2 all-drop">
                                    <div className="filter-over2">
                                        Direct
                                </div>
                                    <div className="filterDropdown2">

                                        <ul>
                                            <li><a href="javascript:void('0')" data-id="All" onClick={this.handleBrokerFilter}>All</a></li>
                                            <li><a href="javascript:void('0')" data-id="Direct" onClick={this.handleBrokerFilter}>Direct</a></li>
                                            <li><a href="javascript:void('0')" data-id="Override" onClick={this.handleBrokerFilter}>Override</a></li>
                                        </ul>

                                    </div>
                                </div> : null
                        }
                        { this.state.userdata.isBrokerTypeUser && this.state.userdata.overrideCount > 0 ? 
                            <div className="filterNewDesign2 all-drop">
                                <div className="filter-over2">
                                    Direct
                                </div>
                                <div className="filterDropdown2">

                                    <ul>
                                        <li><a href="javascript:void('0')" data-id="All" onClick={this.handleBrokerFilter}>All</a></li>
                                        <li><a href="javascript:void('0')" data-id="Direct" onClick={this.handleBrokerFilter}>Direct</a></li>
                                        <li><a href="javascript:void('0')" data-id="Override" onClick={this.handleBrokerFilter}>Override</a></li>
                                    </ul>

                                </div>
                            </div> : null
                        }
                        {
                            this.state.userdata.userrole == "Distributor" && this.state.userdata.overrideCount > 0 ?
                                <div className="filterNewDesign2 all-drop">
                                    <div className="filter-over2">
                                        Direct
                                </div>
                                    <div className="filterDropdown2">

                                        <ul>
                                            <li><a href="javascript:void('0')" data-id="All" onClick={this.handleFilterClick}>All</a></li>
                                            <li><a href="javascript:void('0')" data-id="Direct" onClick={this.handleFilterClick}>Direct</a></li>
                                            <li><a href="javascript:void('0')" data-id="Override" onClick={this.handleFilterClick}>Override</a></li>
                                        </ul>

                                    </div>
                                </div> : null
                        }
                        {
                            this.state.userdata.isBrokerTypeUser == false && this.state.userdata.isLegacyUser == true ?
                                <div className="radio-button-section">
                                    <form>
                                        {
                                            this.state.ClaimType.map((p, index) => {
                                                return (<div id={'repeat' + index}>
                                                    <formgroup className="radio-design custom-tooltip">
                                                        <input type="radio" id={p.id} className="form-control" name="rxsprocrss" value={p.value} checked={p.isChecked} onClick={this.HandleRXSRadioButton.bind(this)} />
                                                        <label class="checkmark" for={p.id}>{p.pname}</label>
                                                    </formgroup>
                                                </div>
                                                )
                                            })
                                        }
                                    </form>
                                </div> : null
                        }
                        {
                            this.state.userdata.userrole == "Distributor" ?
                                <span className="newFilterIcon" onClick={this.toggleDisFilterPopup.bind(this)} ><img className="FilterIcon" src={Filter_Icon} alt="" /></span> : null
                        }
                        {
                            this.state.userdata.userrole == "Wholesaler" ?
                                <span className="newFilterIcon" onClick={this.toggleWhFilterPopup.bind(this)} ><img className="FilterIcon" src={Filter_Icon} alt="" /></span> : null
                        }
                        {
                            this.state.userdata.userrole == "Admin" ?
                                <span className="newFilterIcon" onClick={this.toggleAdFilterPopup.bind(this)} ><img className="FilterIcon" src={Filter_Icon} alt="" /></span> : null
                        }
                        {
                            this.state.DisFilterPopup ?
                                <DisFilterPopup text='Filter' whname={this.state.userdata.wholesaler} dashboard_name={this.state.dashboardName} DisFilterclosePopup={this.toggleDisFilterPopup.bind(this)} handlechangea={this.handlechangea} FilterData={this.state.UserFilter} DisEmail={this.state.userdata.email} /> : null
                        }
                        {
                            this.state.WhFilterPopup ?
                                <WhFilterPopup text='Filter' whname={this.state.userdata.wholesaler} wholesaler_name={this.state.dashboardName} WhFilterclosePopup={this.toggleWhFilterPopup.bind(this)} handlechangea={this.handlechangea} FilterData={this.state.UserFilter} /> : null
                        }
                        {
                            this.state.AdFilterPopup ?
                                <AdFilterPopup text='Filter' AdFilterclosePopup={this.toggleAdFilterPopup.bind(this)} FilterData={this.state.UserFilter} handlechangea={this.handlechangea} /> : null
                        }
                    </div>
                    {
                        this.state.ConfirmReloadPopUp ?
                            <ConfirmReload titleText={this.state.ConfirmationMessageTitle} closePopup={this.ConfirmReloadPopUp.bind(this)} radioButtonSelection={this.state.radioButtonSelection} radioButtonValue={this.state.radioButtonValue} HandleRadioButtonConfirmation={this.HandleRadioButtonConfirmation.bind(this)} searchTextSelection={this.state.searchTextSelection} HandleSearchTextConfirmation={this.HandleSearchTextConfirmation.bind(this)} SearchTextType={this.state.searchTextType} SearchTextValue={this.state.searchTextValue} /> : null
                    }
                </div>
            </div >
        )
    }
}
export default TopMenu;